<template>
  <chart-card :loading="loading" :title="$t('message.views.workbench.ito')" :total="(itoData.thisMonth*100).toFixed(2)+'%'">
    <a-tooltip :title="$t('message.views.workbench.dashboardDescription.inventoryTurnOver')" slot="action">
      <a-icon type="info-circle-o"/>
    </a-tooltip>
    <div>
      <mini-progress color="rgb(19, 194, 194)" :target="50" :percentage="itoData.thisMonth*10" height="8px"/>
    </div>
    <template slot="footer">
      <a-row>
        <a-col :span="12">
          <trend :flag="itoData.thisMonth>itoData.thisMonthLastYear?'up':'down'" style="margin-right: 16px;">
            <span slot="term">{{ $t('message.views.workbench.yoy') }}</span>
            {{ ((itoData.thisMonth-itoData.thisMonthLastYear)*100/itoData.thisMonthLastYear).toFixed(2)+'%'}}
          </trend>
        </a-col>
        <a-col>
          <trend :flag="itoData.thisMonth>itoData.lastMonth?'up':'down'">
            <span slot="term">{{ $t('message.views.workbench.mom') }}</span>
            {{ ((itoData.thisMonth-itoData.lastMonth)*100/itoData.lastMonth).toFixed(2)+'%'}}
          </trend>
        </a-col>
      </a-row>
    </template>
  </chart-card>
</template>

<script>
import request from '../../../utils/request'
import {
  ChartCard,
  Trend,
  MiniProgress
} from '../../../components'
export default {
  name: 'InventoryTurnOver',
  data () {
    return {
      itoData: {},
      loading: false
    }
  },
  components: {
    ChartCard,
    Trend,
    MiniProgress
  },
  methods: {
    getItoData () {
      request({
        url: '/dashboard/ito',
        method: 'get'
      }).then(response => {
        // response.data = json
        this.itoData = response.data.model
      })
    }
  },
  mounted () {
    this.getItoData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/InventoryTurnOver.vue